import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ToastrAlertService {
  constructor(
    private toastr: ToastrService,
    private router: Router,
    private translateService: TranslateService
  ) {}

  toastrSuccess(message, routerLink: string = "", id: string = "") {
    if (!this.checkPreviousAlerts(message)) {
      this.toastr.success(message, "Operación realizada correctamente:", {
        timeOut: 3000,
        positionClass: "toast-top-center",
        enableHtml: true,
      });
      if (routerLink !== "") {
        this.redirect(routerLink, id);
      }
    }
  }

  toastrFail(message, routerLink: string = "", id: string = "") {
    if (!this.checkPreviousAlerts(message)) {
      this.toastr.error(message, "Se ha producido un error:", {
        timeOut: 8000,
        positionClass: "toast-top-center",
        enableHtml: true,
      });
      if (routerLink !== "") {
        this.redirect(routerLink, id);
      }
    }
  }

  toastrWarning(message, routerLink: string = "", id: string = "") {
    if (!this.checkPreviousAlerts(message)) {
      this.toastr.warning(message, "Aviso:", {
        timeOut: 8000,
        positionClass: "toast-top-center",
        enableHtml: true,
      });
      if (routerLink !== "") {
        this.redirect(routerLink, id);
      }
    }
  }
  toastrInfo(message, routerLink: string = "", id: string = "") {
    if (!this.checkPreviousAlerts(message)) {
      this.toastr.info(message, "", {
        timeOut: 8000,
        positionClass: "toast-top-center",
        enableHtml: true,
      });
      if (routerLink !== "") {
        this.redirect(routerLink, id);
      }
    }
  }
  toastFailBlob(blob: any, routerLink: string = "", id: string = "") {
    var reader = new FileReader();
    reader.onload = (e: any) => {
      this.toastrFail(JSON.parse(e.target.result).mensaje, routerLink, id);
    };

    reader.readAsText(blob);
  }

  redirect(routerLink, id) {
    if (id !== "") {
      this.router.navigate([routerLink, id]);
    } else {
      this.router.navigate([routerLink]);
    }
  }

  showWarning(history: boolean, notHistory: boolean) {
    if (history && notHistory) {
      let message = this.translateService.instant("messages.notFoundResutls");
      this.toastrWarning(message);
    }
  }

  checkPreviousAlerts(message) {
    let elements = document.getElementsByClassName("toast-message");
    let lastAlert = elements.length > 0 ? elements[0].innerHTML : "";

    return lastAlert === message;
  }
}
